import React from 'react'

import { GALLERY_IMAGES } from '../../constants'

function ModelGallery() {
  return (
    <div className="conference-sign-in-modal__gallery" aria-hidden="true">
      {GALLERY_IMAGES.map(({ name, src, alt, isTall }) => (
        <div
          key={name}
          className={
            isTall
              ? 'conference-sign-in-modal__cell conference-sign-in-modal__cell--tall'
              : 'conference-sign-in-modal__cell'
          }
        >
          <img className="conference-sign-in-modal__cell-image" src={src} alt={alt} />
        </div>
      ))}
    </div>
  )
}

export default ModelGallery
